const DashboardIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22222 8.88889H0.888889C0.4 8.88889 0 8.48889 0 8V0.888889C0 0.4 0.4 0 0.888889 0H6.22222C6.71111 0 7.11111 0.4 7.11111 0.888889V8C7.11111 8.48889 6.71111 8.88889 6.22222 8.88889ZM6.22222 15.9999H0.888889C0.4 15.9999 0 15.5999 0 15.111V11.5555C0 11.0666 0.4 10.6666 0.888889 10.6666H6.22222C6.71111 10.6666 7.11111 11.0666 7.11111 11.5555V15.111C7.11111 15.5999 6.71111 15.9999 6.22222 15.9999ZM9.77859 16.0001H15.1119C15.6008 16.0001 16.0008 15.6001 16.0008 15.1112V8.0001C16.0008 7.51121 15.6008 7.11121 15.1119 7.11121H9.77859C9.28971 7.11121 8.88971 7.51121 8.88971 8.0001V15.1112C8.88971 15.6001 9.28971 16.0001 9.77859 16.0001ZM8.88971 4.44444V0.888889C8.88971 0.4 9.28971 0 9.77859 0H15.1119C15.6008 0 16.0008 0.4 16.0008 0.888889V4.44444C16.0008 4.93333 15.6008 5.33333 15.1119 5.33333H9.77859C9.28971 5.33333 8.88971 4.93333 8.88971 4.44444Z"
        fill="#006299"
      />
    </svg>
  );
};

export default DashboardIcon;
